<template>
	<template v-if="session.isLoading">Loading...</template>
	<template v-else-if="session.error">Error: {{ session.error }}</template>
	<template v-else>
		<router-view v-slot="{ Component }">
			<component :is="Component" />
		</router-view>
	</template>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import type { Session } from "@/type/api";
import { router } from "@/route/config";
import { useSessionStore } from "@/store/session";

const session = useSessionStore();

onMounted(() => {
	session
		.get()
		.then((s: Session) => {
			console.log("session loaded by FullPage", s);
		})
		.catch(() => {
			router.push(`/signin?next=${router.currentRoute.value.fullPath}`);
		});
});
</script>
